import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of profiles
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.gender
   * @param {*} params.country
   * @param {*} params.state
   * @param {*} params.maritalStatus
   */
  getAll(params) {
    return backofficeService.Api().get('profile', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getFavorites(params) {
    return backofficeService.Api().get('/profile/favorites', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  toggleActive(id, data) {
    return backofficeService.Api()
      .put(`profile/${id}/toggleActive`, data)
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },


   toggleLike(id, data) {
    return backofficeService.Api()
      .post(`profile/${id}/like`, data)
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },

  /**
   * Get specific profile by ID
   * @param {*} id
   * @param {*} params
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`profile/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Create a new profile
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('profile', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Update existing profile
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`profile/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Delete specific profile
   * @param {*} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`profile/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}